import React from 'react';
import { Users, Target, Heart, Award } from 'lucide-react';
import { FeatureGrid } from '../components/FeatureGrid';
interface UeberUnsPageProps {
  onNavigate: (page: string) => void;
}
export function UeberUnsPage({
  onNavigate
}: UeberUnsPageProps) {
  const values = [{
    title: 'Radikale Transparenz',
    description: 'Keine versteckten Kosten, kein Kleingedrucktes. Wir kommunizieren offen und ehrlich.',
    icon: Target
  }, {
    title: 'Kompromissloser Kundenfokus',
    description: 'Wir arbeiten für Sie, nicht für die Versicherungen. Ihre Interessen stehen an erster Stelle.',
    icon: Heart
  }, {
    title: 'Exzellenz & Teamgeist',
    description: 'Gemeinsam stark. Unser Team aus Top-Experten arbeitet Hand in Hand für Ihren Erfolg.',
    icon: Users
  }];
  return <div className="min-h-screen bg-white" data-id="element-604">
      <div className="bg-slate-900 text-white py-32 relative overflow-hidden" data-id="element-605">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-blue-900/20 to-slate-900" data-id="element-606"></div>
        <div className="container mx-auto px-4 text-center relative z-10" data-id="element-607">
          <h1 className="text-5xl md:text-6xl font-bold mb-8 tracking-tight" data-id="element-608">
            Wir machen Versicherungen{' '}
            <span className="text-blue-400" data-id="element-609">einfach</span>.
          </h1>
          <p className="text-xl md:text-2xl text-slate-300 max-w-3xl mx-auto leading-relaxed" data-id="element-610">
            Unsere Mission ist es, jedem Menschen Zugang zu transparenter,
            fairer und erstklassiger Finanzberatung zu ermöglichen.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-24" data-id="element-611">
        <div className="grid md:grid-cols-2 gap-16 items-center mb-32" data-id="element-612">
          <div data-id="element-613">
            <div className="inline-flex items-center gap-2 rounded-full bg-blue-100 px-4 py-1.5 text-sm font-medium text-blue-700 mb-6" data-id="element-614">
              <Award className="h-4 w-4" data-id="element-615" />
              <span data-id="element-616">Unsere Geschichte</span>
            </div>
            <h2 className="text-4xl font-bold text-slate-900 mb-8" data-id="element-617">
              Vom Startup zum Marktführer
            </h2>
            <div className="space-y-6 text-lg text-slate-600 leading-relaxed" data-id="element-618">
              <p data-id="element-619">
                Gegründet im Jahr 2020, startete SmartProtect24 mit einer
                einfachen, aber revolutionären Idee: Versicherungen sollten
                nicht kompliziert, sondern smart sein.
              </p>
              <p data-id="element-620">
                Was als kleiner Vergleichsrechner begann, ist heute Deutschlands
                führende Plattform für digitales Finanzmanagement. Wir verbinden
                modernste KI-Technologie mit menschlicher Premium-Expertise.
              </p>
              <p data-id="element-621">
                Heute vertrauen uns über 50.000 Kunden ihre finanzielle
                Sicherheit an. Und wir stehen erst am Anfang unserer Reise.
              </p>
            </div>
          </div>
          <div className="relative" data-id="element-622">
            <div className="absolute inset-0 bg-blue-600 rounded-3xl rotate-3 opacity-10" data-id="element-623"></div>
            <div className="bg-slate-100 rounded-3xl h-[500px] flex items-center justify-center relative z-10 shadow-xl overflow-hidden" data-id="element-624">
              <div className="absolute inset-0 bg-gradient-to-br from-slate-200 to-slate-300" data-id="element-625"></div>
              <span className="text-slate-400 font-medium text-xl relative z-20" data-id="element-626">
                [Team Foto Placeholder]
              </span>
            </div>
          </div>
        </div>

        <FeatureGrid title="Unsere Werte" subtitle="Das Fundament unserer täglichen Arbeit." features={values} data-id="element-627" />

        <div className="mt-32 text-center" data-id="element-628">
          <h2 className="text-4xl font-bold text-slate-900 mb-16" data-id="element-629">
            Das Leadership Team
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-630">
            {[1, 2, 3, 4].map(i => <div key={i} className="flex flex-col items-center group" data-id="element-631">
                <div className="w-48 h-48 rounded-full bg-slate-200 mb-6 overflow-hidden shadow-lg border-4 border-white group-hover:border-blue-100 transition-all" data-id="element-632">
                  <div className="w-full h-full bg-gradient-to-br from-slate-300 to-slate-400" data-id="element-633"></div>
                </div>
                <h3 className="font-bold text-xl text-slate-900 mb-1" data-id="element-634">
                  Max Mustermann
                </h3>
                <p className="text-blue-600 font-medium" data-id="element-635">Co-Founder & CEO</p>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}